import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useGetCandidateByIdQuery } from '../../../slice/candiddateApiSlice';
import Comments from './Comments';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCandidatesFilters, selectcurrType, selectHasRunningAutomation, selectIsFullCv, selectIsSendEmailOpen,
    setCandidateCv, setCandidateProfile, setCandidatesFilter, setComparisonCandidates, setCurrentHiringStages,
    setCurrentType, setHasRunningAutomation, setIsFetchingCandidateData, setIsFullCv, setIsSendEmailOpen
} from '../../../slice/candidateSlice';
import { Button } from 'antd';
import { apiStatuses, errorMessage } from '../../../../../shared/utils/constantData';
import LazyLoader from '../../../../../shared/components/LazyLoader/load';
import { selectAllRolesPermissions, setRolePermissionsPerJob } from '../../../../authentication/slice/authSlice';
import Chart from './Chart';
import { currentTypes, ICandidatesFilter } from '../../../../../shared/utils/interfaces/candidatesListFace';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../../../shared/utils/analytics';
import ProfileToggle from './ProfileToggle';
import { Warning } from '../../../../../shared/components/Warning/Warning';
import { DocViewerRef } from '@cyntler/react-doc-viewer';
import { getImageUrl } from '../../../../../shared/utils/functions/images';
import { CVViewer } from '../../../../../shared/components/pdf/CVViewer';
import ComposeEmail from '../SendEmail/ComposeEmail';
import AutomatedActionsNotifications from '../AutomatedActionsNotifications';
import { MoveCandidatesModal } from '../../../../../shared/components/Modals/MoveCandidatesModal';
import { setActiveTab } from '../../../slice/jobSlice';
import { Toolbar } from '../../../../../shared/components/pdf/Toolbar';
import RecordedInterview from '../../../../aiInterviewer/components/recordedInterview';
import ViewEvaluationModal from '../../../../aiInterviewer/components/viewEvaluationModal';
import CoverLetterText from './CoverLetter';

export const Profile = () => {
    const { applicationId, jobId } = useParams();
    const dispatch = useDispatch();
    const allRolesPermissions = useSelector(selectAllRolesPermissions)
    const isFullCv = useSelector(selectIsFullCv);
    const { data, isSuccess, isLoading, isError, error } = useGetCandidateByIdQuery(applicationId, { refetchOnMountOrArgChange: true });
    const currentType = useSelector(selectcurrType);
    const navigate = useNavigate();
    const location = useLocation()
    const docViewerRef = useRef<DocViewerRef>(null);
    const isSendEmailOpen = useSelector(selectIsSendEmailOpen);
    const hasRunningAutomation = useSelector(selectHasRunningAutomation);
    const candidatesFilter: ICandidatesFilter = useSelector(selectCandidatesFilters);
    const [currentTab, setCurrentTab] = useState(JSON.parse(localStorage.getItem("currentTab") || 'null'));

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, [applicationId]);
    
    useEffect(() => {
        if (isSuccess && !currentTab) {
            setCurrentTab(data?.application?.pipelineStage);
        }
    }, [isSuccess, data, currentTab])

    useEffect(() => {
        dispatch(setIsFetchingCandidateData(isLoading));
    }, [isLoading, dispatch])

    useEffect(() => {
        if (isSuccess) {
            dispatch(setCandidateProfile(data?.application));
            dispatch(setComparisonCandidates([data?.application]))
            dispatch(setCurrentHiringStages(data?.application?.pipelineStages.map((stage: any) => ({ id: stage?.id, name: stage?.name, count: '0', globalstagetypeid: stage?.companyStageType?.globalStageTypeId }))));
            dispatch(setCandidateCv(data?.application?.cv))
            dispatch(setRolePermissionsPerJob({ role: data?.application?.userRole?.roleName, permissions: allRolesPermissions ? allRolesPermissions[data?.application?.userRole?.roleName].permissions : [] }))
            dispatch(setHasRunningAutomation(data?.application?.hasRunningAutomation))
            logEvent(analytics, 'View candidate Profile')
        }
    }, [isSuccess, data, dispatch, allRolesPermissions]);

    
    useEffect(() => {
        dispatch(setCurrentType(currentTypes.CV));

        return () => {
            dispatch(setCurrentType(currentTypes.CV));
        };
    }, [applicationId, dispatch]);

    useEffect(() => {
        const currentTab = JSON.parse(localStorage.getItem("currentTab") || 'null');

        if (!candidatesFilter?.hiringStageId && currentTab?.id) {
            dispatch(setCandidatesFilter({...candidatesFilter, hiringStageId: currentTab?.id }))
        }
        //eslint-disable-next-line
    }, [dispatch])

    useEffect(() => {
        const handleBeforeUnload = () => {
            if (currentTab) {
                localStorage.setItem("currentTab", JSON.stringify(currentTab));
            }
            localStorage.setItem("isRefreshing", "true");
        };
        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            dispatch(setIsSendEmailOpen(false));
            const refreshing = localStorage.getItem("isRefreshing") === "true";

            if (!refreshing) {
                dispatch(setIsFullCv(false));
            }
            
            localStorage.removeItem("isRefreshing");
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [dispatch, currentTab]);

    const handleNavigationBack = () => {
        if (location?.state?.fromSearch) {
            navigate(`/search${location.state?.search}`)
        } else if (location?.state?.fromSimilarity) {
            navigate(`/similarApplication/${location?.state?.applicationId}`)
        } else {
            navigate(`/jobs/${jobId}/candidates${location.state?.search}`);
        }
    }

    useEffect(() => {
        const handlePopState = () => {
            dispatch(setActiveTab(currentTab?.name))
            dispatch(setCandidatesFilter({ ...candidatesFilter, hiringStageId: currentTab?.id }));
        };
        window.addEventListener('popstate', handlePopState);
        //eslint-disable-next-line
    }, [location, currentTab]);

    return (
        <>
            {isLoading ?
                <div className="container flex items-center justify-center w-screen h-screen">
                    <div className='w-full max-w-2xl mb-4'>
                        <LazyLoader />
                        <p className='mt-4 text-base font-normal text-indigo-600'>Retrieving candidate data..</p>
                    </div>
                </div>
                : isSuccess || data ?
                    <>
                        <div className='flex flex-wrap pt-2 lg:flex-nowrap'>
                            <div className="flex-shrink w-full lg:w-auto px-7">
                                <div className='sticky top-0 left-0 bg-light-100'>
                                    <Button className="p-0 my-3 text-indigo-700 border-0 shadow-none btn-md min-w-max" onClick={() => {
                                        localStorage.removeItem("currentTab");
                                        handleNavigationBack();
                                    }}>
                                        <img src={getImageUrl('blueLeftArrow')} className="inline w-4 mr-2 btn-icon" alt="back" />
                                        <span className="inline">Back</span>
                                    </Button>
                                    <ProfileToggle docViewerRef={docViewerRef} />
                                </div>
                            </div>
                            <div className={`shrink grow min-w-0 ${isFullCv ? 'basis-full' : 'basis-full lg:basis-[50%]'} ${data?.application?.cv?.split('.').pop() === 'docx' && currentType === currentTypes.CV ? 'h-[50vh]' : ''} ${data?.application?.cv?.split('.').pop() === 'docx' && isFullCv ? 'lg:mr-7' : ''} `}>
                                {currentType === currentTypes.Graph ? 
                                <div>
                                    <Toolbar />
                                    <div className='mt-14'><Chart /></div>
                                </div>
                                    : currentType === currentTypes.coverLetter ? <CoverLetterText />
                                        : <CVViewer docViewerRef={docViewerRef} />}
                            </div>
                            {isFullCv || <div className='basis-full lg:basis-[50%] grow'>
                                <Comments />
                            </div>}
                        </div>
                        <div className={`${!isSendEmailOpen ? 'opacity-0 pointer-events-none !pb-0' : ''} w-full pb-14`}>
                            <ComposeEmail />
                        </div>
                        {hasRunningAutomation ? <AutomatedActionsNotifications /> : null}

                    </>
                    : isError ?
                        <Warning className='pt-24' title={error?.data?.statusCode === apiStatuses.requestForbidden ? "You don’t have access rights to view this candidate." : errorMessage} message={error?.data?.statusCode === apiStatuses.requestForbidden ? '' : 'Please refresh to try again'} withRefreshBtn={false} />
                        : null
            }
            <MoveCandidatesModal isProfilePage={true} />
            <RecordedInterview />
            <ViewEvaluationModal />
        </>
    )
}
